@if (state$ | async; as state) {
  <div class="page-wrapper">
    <header class="po-row main-header">
      <div class="logo-container">
        <a class="logo-link" [href]="jobPortalUrl" [title]="'l-logo-title' | translate">
          <img
            class="logo-img"
            [src]="'assets/ats-lib-assets/themes/trampo/images/logo.svg'"
            alt="'l-logo-title' | translate"
            aria-hidden="true"
          />
        </a>
      </div>
      <div class="header-login-container">
        <a
          class="header-login-link"
          href="/"
          target="_blank"
          [title]="'l-access-your-account' | translate"
          data-cy="header-login-link"
        >
          {{ 'l-access-your-account' | translate }}
        </a>
      </div>
    </header>
    <div class="container full-page po-pl-sm-2 po-pr-sm-2 po-pl-md-2 po-pr-md-2 main-content">
      <section class="header">
        <div class="po-row po-mb-lg-2 po-pl-lg-1 search-section">
          <div class="po-sm-12 po-lg-2 po-xl-2 po-p-0 po-mb-sm-4 po-mb-md-4 image-container">
            <img
              [src]="'assets/images/pipo_lupa.svg'"
              width="109"
              height="141"
              alt="lupa"
              aria-hidden="true"
            />
          </div>
          <form
            [formGroup]="formGroup"
            class="po-sm-12 po-mr-md-1 po-ml-md-1 po-lg-10 po-xl-10 po-p-0"
          >
            <h1 for="search" class="label" [innerHtml]="'l-portal-search-label' | translate"></h1>
            <div class="search-container">
              <po-input
                id="search"
                class="po-sm-12 po-lg-10 po-p-0"
                formControlName="filter"
                [p-placeholder]="'l-portal-search-placeholder' | translate"
                (keyup.enter)="filter()"
                data-cy="search-input"
              >
              </po-input>
              <po-button
                class="po-sm-12 po-lg-2 po-p-0 po-p-lg-1 po-mb-sm-1 margin-bottom-md"
                p-kind="primary"
                [p-label]="'l-search' | translate"
                [atsLibFieldAriaLabel]="'l-search' | translate"
                (p-click)="filter()"
                data-cy="search-btn"
                data-gtm="btnSearch"
              ></po-button>
            </div>
            <ats-tip-accordion
              class="po-mt-1"
              [icon]="'an an-funnel'"
              [title]="'l-advanced-filter' | translate"
            >
              <div class="accordion-tip-content">
                <div class="po-row po-mb-2">
                  <div class="po-sm-12 po-md-6 po-lg-3 po-p-sm-0 po-mb-sm-2 po-mb-md-0 po-pl-0">
                    <po-combo
                      class="po-sm-12 po-p-0 po-mb-sm-2 po-mb-md-3"
                      formControlName="stateId"
                      data-cy="combo-state"
                      [p-label]="'l-state' | translate"
                      [atsLibFieldAriaLabel]="'l-state' | translate"
                      [p-placeholder]="'l-state-search-placeholder' | translate"
                      [p-filter-service]="stateUrl"
                      [p-filter-params]="comboParams"
                      name="stateId"
                      (p-change)="onChangeState($event)"
                      [p-field-label]="'name'"
                      [p-field-value]="'id'"
                      [p-infinite-scroll]="true"
                    >
                    </po-combo>
                    <po-combo
                      class="po-sm-12 po-p-0"
                      formControlName="cityId"
                      data-cy="combo-city"
                      [p-label]="'l-city' | translate"
                      [atsLibFieldAriaLabel]="'l-city' | translate"
                      [p-placeholder]="'l-city-search-placeholder' | translate"
                      [p-filter-service]="cityUrl"
                      [p-filter-params]="comboParams"
                      name="cityId"
                      (p-change)="onChangeCity($event)"
                      [p-field-label]="'name'"
                      [p-field-value]="'id'"
                      [p-infinite-scroll]="true"
                    ></po-combo>
                  </div>
                  <div class="po-sm-12 po-md-9 po-lg-6 po-p-sm-0 po-pr-md-0 po-pl-lg-1">
                    <po-combo
                      class="po-sm-12 po-lg-6 po-mb-sm-2 po-mb-md-3 po-p-sm-0 po-pr-md-0 po-pr-lg-1"
                      formControlName="careerPageId"
                      data-cy="combo-company"
                      [p-label]="'l-company' | translate"
                      [atsLibFieldAriaLabel]="'l-company' | translate"
                      [p-placeholder]="'l-company-search-placeholder' | translate"
                      [p-filter-service]="companyUrl"
                      [p-filter-params]="comboParams"
                      name="careerPageId"
                      [p-field-label]="'divulgationName'"
                      [p-field-value]="'id'"
                      [p-infinite-scroll]="true"
                    ></po-combo>
                    @if (publicationPeriodOptions$ | async; as options) {
                      <po-select
                        class="po-sm-12 po-lg-6 po-p-sm-0 po-pr-md-0 po-pr-lg-1 po-pl-lg-2"
                        formControlName="publicationRange"
                        name="publicationRange"
                        [p-label]="'l-published-at-date' | translate"
                        [p-options]="options"
                        [p-placeholder]="'l-published-at-search-placeholder' | translate"
                        data-cy="multiselect-publication-date"
                      ></po-select>
                    }

                    @let controlHiringRegime = formGroup.get('hiringRegime');
                    @if (controlHiringRegime) {
                      <div class="po-pr-0" data-cy="job-system">
                        @let hiringRegimeOptions = hiringRegimeOptions$ | async;
                        @if (hiringRegimeOptions) {
                          <ats-lib-multiselect
                            [p-label]="'l-hiring-regime' | translate"
                            class="po-sm-12 po-p-sm-0 po-pr-md-0 po-pr-lg-1"
                            formControlName="hiringRegime"
                            [p-placeholder]="'l-write-hiring-regime' | translate"
                            data-cy="multiselect-hiring-regime"
                            [p-options]="hiringRegimeOptions"
                            [p-hide-search]="true"
                          />
                        }
                      </div>
                    }
                  </div>

                  <div class="po-sm-12 po-md-6 po-lg-3 po-pl-md-2 po-pl-lg-3">
                    <div class="checkbox-align" data-cy="checkbox-opening-type">
                      <p tabindex="0" class="checkbox-label">{{ 'l-work-model' | translate }}</p>
                      <po-checkbox
                        name="checkbox"
                        [p-label]="'l-presential' | translate"
                        formControlName="isLocal"
                      >
                      </po-checkbox>
                      <po-checkbox
                        name="checkbox"
                        [p-label]="'l-hybrid' | translate"
                        formControlName="isHybrid"
                      >
                      </po-checkbox>
                      <po-checkbox
                        name="checkbox"
                        [p-label]="'l-remote' | translate"
                        formControlName="isHomeOffice"
                      >
                      </po-checkbox>
                    </div>
                    <p class="checkbox-label f-bold">
                      {{ 'l-easy-apply' | translate }}
                    </p>
                    <po-switch
                      class="po-sm-12 po-lg-4 po-p-sm-0 po-pl-lg-0 po-mb-2"
                      formControlName="isJobApplicationSimplified"
                      [p-label]="'l-easy-apply' | translate"
                      [p-label-off]="'l-desactivate' | translate"
                      [p-label-on]="'l-activate' | translate"
                      data-cy="is-easy-apply"
                      [atsLibFieldAriaLabel]="'l-easy-apply' | translate"
                    />
                  </div>
                </div>
                <div class="po-row filter-footer">
                  <div class="po-sm-12 po-p-0">
                    <po-button
                      class="po-sm-12 po-md-6 po-offset-lg-8 po-lg-2 po-offset-xl-8 po-xl-2 po-p-sm-0 po-pl-md-0 po-pr-lg-0"
                      [p-label]="'l-clear-filter' | translate"
                      (p-click)="clear(); announceClearSearch()"
                      data-cy="btn-clear"
                      p-kind="secondary"
                    ></po-button>
                    <po-button
                      class="po-sm-12 po-md-6 po-lg-2 po-xl-2 po-pl-md-2 po-p-sm-0 po-mb-sm-1 po-pr-0"
                      [p-label]="'l-filter-button' | translate"
                      (p-click)="filter()"
                      data-cy="btn-filter-item"
                      data-gtm="btnSearch"
                      p-kind="primary"
                      [p-disabled]="formGroup.invalid"
                    ></po-button>
                  </div>
                </div>
              </div>
            </ats-tip-accordion>
          </form>
        </div>
      </section>
      <div
        class="po-mt-sm-2 po-mb-sm-2 po-m-md-1 po-mb-md-2 po-mb-2 po-mb-xl-3 job-opportunity-counter"
      >
        @if (!isSearchMeaningful()) {
          <h2>{{ 'l-portal-subtitle' | translate }}</h2>
        }
        @if (isSearchMeaningful()) {
          <h2>{{ 'l-portal-subtitle-meaningful' | translate }}</h2>
        }
      </div>
      <section class="content">
        @for (item of state.page; track trackByItemId(i, item); let i = $index) {
          <div class="po-xl-4 po-lg-4 po-sm-12 po-mb-2 po-p-sm-0 po-pr-lg-1">
            <ats-job-opportunity-card [item]="item"></ats-job-opportunity-card>
          </div>
        }
        @if (state.page?.length === 0) {
          <div class="po-sm-12 po-p-sm-0 fs-italic">
            {{ 'l-empty-portal' | translate }}
          </div>
        }
        <ats-lib-loader-global [menuInitialized]="false"></ats-lib-loader-global>
      </section>
      <div class="po-row pagination-footer">
        <ats-lib-numbered-pagination
          [currentPage]="state.pageNumber"
          [totalPages]="999"
          [hasNext]="state.hasNext"
          [disabled]="state.isLoading"
          (pageChange)="onPageChange($event)"
        ></ats-lib-numbered-pagination>
      </div>
    </div>
    <footer class="footer">
      <div class="custom-footer">
        <div class="footer-container">
          <div class="footer-columns">
            <div class="figure">
              <img
                class="po-sm-12 po-lg-2 po-xl-1 po-p-0"
                [src]="'assets/images/logo_branco.svg'"
                width="191"
                height="70"
                [alt]="'l-logo-title' | translate"
                aria-hidden="true"
              />
            </div>
            <p class="po-mt-4 po-pb-5">
              {{ 'l-portal-footer-message' | translate }}
            </p>
          </div>
          <nav class="footer-columns">
            <div class="links">
              <p class="f-bold po-mb-1">
                {{ 'l-quickly-access' | translate }}
              </p>
              <div class="d-inline">
                <a
                  [href]="helpUrl"
                  target="_blank"
                  [title]="'l-job-listing-help-center' | translate"
                  data-cy="help-center-link"
                >
                  {{ 'l-job-listing-help-center' | translate }}
                </a>
              </div>
              <div class="d-inline">
                <a
                  target="_blank"
                  href="/register-user?source=portal"
                  [title]="'l-job-listing-register' | translate"
                  data-cy="register-link"
                  data-gtm="register_user"
                >
                  {{ 'l-job-listing-register' | translate }}
                </a>
              </div>
              <div class="d-inline">
                <a
                  href="/"
                  target="_blank"
                  [title]="'l-job-listing-login' | translate"
                  data-cy="login-link"
                >
                  {{ 'l-job-listing-login' | translate }}
                </a>
              </div>
              @if (termsUseCurrentVersion) {
                <div class="po-mt-2 terms-of-use">
                  <p>
                    <a
                      [href]="
                        `assets/files/terms-of-use/novo-trampo/v${termsUseCurrentVersion}.pdf`
                      "
                      target="_blank"
                      [title]="'l-use-terms' | translate"
                      [attr.data-cy]="`terms-of-use-v${termsUseCurrentVersion}`"
                    >
                      {{ 'l-use-terms' | translate }}
                    </a>
                    {{ 'l-and' | translate }}
                    <a
                      href="https://www.totvs.com/protecao-e-privacidade-de-dados/"
                      target="_blank"
                      [title]="'l-privacy-statement' | translate"
                      data-cy="privacy-statement"
                    >
                      {{ 'l-privacy-statement' | translate }}
                    </a>
                  </p>
                </div>
              }
            </div>
          </nav>
        </div>
      </div>
    </footer>
  </div>
}
